export const utils = {
  methods: {
    async getAllSettled (promises, returnErrors = false) {
      const rejected = []
      const results = await Promise.allSettled(promises)
      const fulfilled = results.flatMap(result => {
        if (result.status === 'rejected') {
          rejected.push(result)
          return []
        }
        return result.value
      })
      if (rejected.length > 0) console.log('Rejected promises:', rejected)
      if (returnErrors) {
        return { fulfilled, rejected }
      }
      return fulfilled
    },
    getUniqueByKey (arr, key) {
      if (arr?.length > 0) {
        const values = arr.map(item => item[key])
        const uniqueValues = Array.from(new Set([...values]))
        return uniqueValues.sort()
      }
      return []
    }
  }
}